import store from '../../store'
import {
    DEVICE_OIL_HISTORY_SET_DATA,
    DEVICE_OIL_HISTORY_SET_DATA_GRAPH,
    DEVICE_OIL_HISTORY_SET_TIME_RANGE,
} from '../device-oil-history'

interface OilHistoryItem {
    createdAt: string | number
    [key: string]: unknown
}

interface OilHistoryItemFormatted extends OilHistoryItem {
    formattedCreatedAt: string
}


/**
 * Set device oil history action
 */
export const setDeviceOilHistoryAction = (data: OilHistoryItem[]): void => {
    const dataToSave: OilHistoryItemFormatted[] = [...data]
        .map(dataItem => {
            return {
                ...dataItem,
                formattedCreatedAt: window.moment.utc(dataItem.createdAt).local().format('D.M.YYYY'),
            }
        })
        .reverse()

    const usedDays: string[] = []
    const dataForGraph = dataToSave.filter(oilHistory => {
        const oilHistoryDay = window.moment
            .utc(oilHistory.createdAt)
            .local()
            .format('L')

        if (usedDays.includes(oilHistoryDay)) {
            return false
        }

        usedDays.push(oilHistoryDay)
        return true
    })

    store.dispatch({
        type: DEVICE_OIL_HISTORY_SET_DATA,
        data: dataToSave,
    })

    store.dispatch({
        type: DEVICE_OIL_HISTORY_SET_DATA_GRAPH,
        data: dataForGraph,
    })
}

/**
 * Set device oil history time range
 */
export const setDeviceOilHistoryTimeRangeAction = (from: number | string | null, to: number | string | null): void => {
    store.dispatch({
        type: DEVICE_OIL_HISTORY_SET_TIME_RANGE,
        from: from,
        to: to,
    })
}
